import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import axios from "axios";
import { Button, notification } from "antd";
class NewVersionNotification extends React.Component {
    interceptor = null;
    constructor(props) {
        super(props);
        this.state = {
            serverVersion: '',
            notificationRaised: false
        };
    }
    componentWillUnmount = () => {
        if (this.interceptor) {
            axios.interceptors.response.eject(this.interceptor);
            this.interceptor = null;
        }
    };
    componentDidMount = () => {
        this.interceptor = axios.interceptors.response.use((response) => {
            const subtruxBuild = response.headers['subtrux-build'];
            if (!this.state.notificationRaised && subtruxBuild && this.state.serverVersion && this.state.serverVersion < subtruxBuild) {
                notification.info({
                    actions: _jsx(Button, { htmlType: "button", onClick: () => window.location.reload(), size: 'large', children: "Update" }),
                    title: 'New version of SubTrux Available',
                    placement: "bottomRight",
                    duration: 0,
                    closable: false
                });
                this.setState({
                    notificationRaised: true
                });
            }
            if (subtruxBuild && this.state.serverVersion !== subtruxBuild) {
                this.setState({
                    serverVersion: subtruxBuild
                });
            }
            return response;
        }, function (error) {
            return Promise.reject(error);
        });
    };
    render() {
        return null;
    }
}
export default NewVersionNotification;
